import { myPageRoutePaths } from './paths';

import type { RouteObject } from 'react-router-dom';

export const myPageRoute: RouteObject = {
  path: myPageRoutePaths.main.path,
  children: [
    {
      index: true,
      async lazy() {
        const MyPage = await import('@/pages/mypage/MyPage');
        return { Component: MyPage.default };
      },
    },
    {
      path: myPageRoutePaths.voteHistory.path,
      async lazy() {
        const VoteHistory = await import('@/pages/vote/VoteHistory');
        return { Component: VoteHistory.default };
      },
    },
    {
      path: myPageRoutePaths.settings.path,
      async lazy() {
        const Setting = await import('@/pages/mypage/Setting');
        return { Component: Setting.default };
      },
    },
    {
      path: myPageRoutePaths.point.path,
      async lazy() {
        const UserPointPage = await import('@/pages/user-point/UserPointPage');
        return { Component: UserPointPage.default };
      },
    },
  ],
};

export const notificationRoute: RouteObject = {
  path: `${myPageRoutePaths.main.path}/${myPageRoutePaths.notifications.path}`,
  async lazy() {
    const Notifications = await import('@/pages/notification/Notifications');
    return { Component: Notifications.default };
  },
};

// TRAD-1964 — 알림 인박스(notificationRoute)와 별개 라우트(팀장 확정: 인박스 하위 서브라우트).
// notificationRoute와 동일하게 PrivateRoute 최상위 children에 등록되므로 전체 경로를 명시해야 한다
// (myPageRoute처럼 my-page 하위 children으로 중첩하지 않음 — notificationRoute 컨벤션을 그대로 따름).
export const notificationSettingsRoute: RouteObject = {
  path: `${myPageRoutePaths.main.path}/${myPageRoutePaths.notificationSettings.path}`,
  async lazy() {
    const NotificationSettingsPage = await import('@/pages/notification-preferences/NotificationSettingsPage');
    return { Component: NotificationSettingsPage.default };
  },
};
